class CustomKlaviyo extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('.js-klaviyo-form')
    this.emailInput = this.querySelector('.js-klaviyo-email')
    this.successMessage = this.querySelector('.js-klaviyo-success')
    this.errorMessageWrapper = this.querySelector('.js-error-wrapper') || false
    this.errorMessageEl =
      this.errorMessageWrapper.querySelector('.js-error-message') || false
    this.url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'
    this.genderInputs = this.querySelectorAll('.js-gender')

    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  serializeForm = (form) => {
    const obj = {}
    const formData = new FormData(form)
    for (const key of formData.keys()) {
      obj[key] = formData.get(key)
    }
    return JSON.stringify(obj)
  }
  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  handleSubmit(e) {
    e.preventDefault()

    this.handleErrorMessage(false)
    this.handleSuccessMessage(false)

    const serialized = JSON.parse(this.serializeForm(this.form))

    if (serialized.email == '') {
      this.emailInput.focus()
      this.emailInput.setAttribute('aria-invalid', 'true')
      this.emailInput.setAttribute('aria-describedby', 'Email is required')
      return this.handleErrorMessage('Email is required')
    }

    if (serialized.email != '' && !this.validateEmail(serialized.email)) {
      this.emailInput.focus()
      this.emailInput.setAttribute('aria-invalid', 'true')
      this.emailInput.setAttribute('aria-describedby', 'Email error')
      return this.handleErrorMessage('Invalid email')
    } else {
      this.emailInput.setAttribute('aria-invalid', 'false')
      this.emailInput.removeAttribute('aria-describedby')
      this.handleErrorMessage(false)
    }

    this.fetchRequest(serialized)
      .then((response) => {
        if (response.errors.length) {
          this.handleErrorMessage(response.errors[0])
        }
        if (response.success && response.data) {
          this.handleSuccessMessage(true)
          this.clearForm()
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  async fetchRequest(data) {
    const formData = {
      g: Shopify.settings.klaviyo.list_id,
      $fields: '$source,Gender',
      email: data.email,
      consent: true,
      $source: 'Newsletter Embed 15% Off',
      Gender: data.Gender,
    }

    const body = new URLSearchParams(formData)

    const req = await fetch(this.url, {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'cache-control': 'no-cache',
      },
      body,
    })

    const response = await req.json()
    return response
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper &&
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.errorMessageEl.textContent = errorMessage
    }
  }

  handleSuccessMessage(state) {
    this.successMessage.classList[state ? 'remove' : 'add']('hidden')
  }

  clearForm() {
    this.handleErrorMessage(false)
    this.emailInput.value = ''
    this.genderInputs.forEach((input) => {
      input.checked = false
    })
    this.genderInputs[0].checked = true
  }
}

customElements.define('custom-klaviyo', CustomKlaviyo)
